import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  accountCard: {
    padding: 0,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease'
  },
  accountCardRejectedAndProcessing: {
    opacity: 0.6
  },
  cardContent: {
    padding: theme.spacing(2),
    '&:last-of-type': {
      paddingBottom: theme.spacing(2)
    }
  },
  accountName: {
    color: theme.palette.primary.main,
    textTransform: 'uppercase'
  },
  statusChip: {
    paddingInline: theme.spacing(0.5),
    border: 'none',
    textTransform: 'uppercase'
  },
  cardActions: {
    padding: theme.spacing(1.5, 3, 2),
    gap: theme.spacing(1.5),
    flexWrap: 'wrap',
    borderTop: `1px solid ${theme.palette.divider}`
  }
}))
